<i [class]="icon"></i>
